import { render } from "./HomePostCollection.vue?vue&type=template&id=acea2968"
import script from "./HomePostCollection.vue?vue&type=script&lang=js"
export * from "./HomePostCollection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__